import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/odds-gate/odds-gate/nextjs/src/components/common/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/odds-gate/odds-gate/nextjs/src/components/common/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/odds-gate/odds-gate/nextjs/src/components/common/PreviewBox/PreviewBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalContextProvider"] */ "/home/runner/work/odds-gate/odds-gate/nextjs/src/lib/globalContext.tsx");
